import actionTypes from '../constants/action-types';

const connectSite = (site) => ({
  type: actionTypes.CONNECT_SITE,
  payload: {
    site,
  },
});

export default connectSite;
